var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3600 3600",
    style: {
      enableBackground: "new 0 0 3600 3600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E5E5E5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1800.2,0c-356,0-704.1,105.6-1000.1,303.4c-296,197.8-526.8,478.9-663,807.8S-34.8,1802,34.6,2151.2 c69.5,349.2,240.9,669.9,492.7,921.6c251.8,251.7,572.5,423.2,921.7,492.6c349.2,69.5,711.2,33.8,1040.1-102.4 c328.9-136.2,610.1-366.9,807.9-663s303.4-644,303.4-1000c-0.3-315.9-83.7-626.1-241.8-899.6c-158-273.5-385.2-500.6-658.7-658.7 S2116.1,0.4,1800.2,0L1800.2,0z M1800.2,3440c-324.4,0-641.5-96.2-911.2-276.4c-269.7-180.2-479.9-436.3-604.1-736 s-156.6-629.4-93.3-947.6c63.3-318.1,219.5-610.3,448.9-839.7s521.6-385.6,839.8-448.8c318.2-63.3,647.9-30.8,947.7,93.3 c299.7,124.1,555.9,334.3,736.1,604c180.2,269.7,276.4,586.8,276.4,911.1c0,287.9-75.8,570.7-219.7,820 c-144,249.3-351,456.3-600.3,600.3C2371,3364.2,2088.1,3440,1800.2,3440L1800.2,3440z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1800.2,620.4l-1176.1,1176l113.2,113.2l191.6-192v1005.6h1742.2V1717.6l192,192l113.2-113.2L1800.2,620.4z  M1995,2563.2h-389.6V2020H1995V2563.2z M2511.1,2563.2h-356V1860h-709.7v703.2h-356.4V1557.6l711.3-710.8l710.9,710.8V2563.2z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFalse);
export default __webpack_public_path__ + "static/media/home-false.dfe5744ff12644779e28c0f750c5341d.svg";
export { ForwardRef as ReactComponent };